import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import moment from 'moment';

class AssetDetailNotes extends Component {
  render = () => {
    const notes =
      (this.props.asset._notes && this.props.asset._notes.filter((note) => !note.deleted)) || [];
    return (
      <Form.Section title={this.props.t('assets.section.notes')}>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th width="50%">{this.props.t('assets.fields.notes.text')}</th>
              <th width="20%">{this.props.t('assets.fields.notes.createdAt')}</th>
              <th width="20%">{this.props.t('assets.fields.notes.createdBy')}</th>
            </tr>
          </thead>
          <tbody>
            {notes.length === 0 && (
              <tr>
                <td colSpan="4">
                  <div className="alert alert-info text-center mb-0">
                    <i className="fa fa-lg fa-info-circle pr-3" />
                    {this.props.t('assets.fields.notes.empty')}
                  </div>
                </td>
              </tr>
            )}
            {notes.map((note) => (
              <tr key={note.id}>
                <td>{note.text}</td>
                <td>{moment(note.createdAt).format('DD/MM/YYYY')}</td>
                <td>
                  {note.createdBy.name} {note.createdBy.lastname}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Form.Section>
    );
  };
}

export default translate()(AssetDetailNotes);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailNotes.js